import { ScrollToTop } from "@/components/scroll-to-top.tsx";
import { Toaster } from "@/components/ui/sonner.tsx";
import "@/instrument.ts";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <App />
      <Toaster richColors />
    </BrowserRouter>
  </StrictMode>,
);
